import React from 'react'
import styled from '@emotion/styled'
import { Typography, TypographyProps } from '@mui/material'
import circlesOrbitColorPalette from 'common/ui/circlesColorTheme'

const StyleFont = styled(Typography)({
  color: circlesOrbitColorPalette.text.main,
  fontSize: '16px',
  fontWeight: 600,
  margin: '8px 0'
})

const TextColorFontHeader = (props: TypographyProps) => {
  const { children, ...restProps } = props
  return <StyleFont {...restProps}>{children}</StyleFont>
}

export default TextColorFontHeader
